import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AddCouponWithClient, AddOrganisationRequest, AddServiceCategoryRequest, CouponCodes, CouponServicesResponse, CreateCouponMasterRequest, EligibleCoupons, GenerateCouponCodesRequest, UpdateCouponLinkRequest,UpdateCouponMasterRequest } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppErrors, NotFoundError } from '@fitness-force/errors';

@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private http: HttpClient, private router: Router) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  createCoupon(tenantId: number,createCouponMasterRequest: CreateCouponMasterRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master`,createCouponMasterRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateCouponMaster(tenantId: number,couponMasterId: number, updateCouponMasterRequest: UpdateCouponMasterRequest)
  {
    return this.http.put(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}`,updateCouponMasterRequest,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  // Charge Master
  getCoupons(tenantId: number, allParams: Array<string> = []) {
    let parsedParams = new HttpParams()
    if (allParams.length > 0) {

      allParams.forEach((p: any) => {

        parsedParams = parsedParams.append(p.name, p.value);
      });
    }
    return this.http
      .get(
        `${environment.BASE_URL}/tenants/${tenantId}/offer_master`,
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getSingleCoupon(tenantId: number, couponId: number) {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}`,this.httpOptions )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getCouponsByMasterid(tenantId: number, couponId: number) {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/coupons`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  getEligibleClients(tenantId: number, couponId: number) {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_clients`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  AddEligibleClients(tenantId: number, couponId: number, addClientToCoupon:AddCouponWithClient) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_clients`, addClientToCoupon,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  RemoveEligibleClients(tenantId: number, couponId: number, coupon_client_link_id:number) {
    return this.http.delete(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_clients/${coupon_client_link_id}`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GenerateMoreCoupons(tenantId: number, couponId: number, generateCoupons:GenerateCouponCodesRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/coupons`, generateCoupons,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateCoupenMasterCouponLink(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number, updateCoupon:UpdateCouponLinkRequest) {
    return this.http.put(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}/coupons/${couponMasterCouponLinkId}`, updateCoupon,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkCouponCodeLinkActive(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}/coupons/${couponMasterCouponLinkId}/mark_as_active`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkCouponCodeLinkInActive(tenantId: number, couponMasterId: number,couponMasterCouponLinkId: number) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}/coupons/${couponMasterCouponLinkId}/mark_as_inactive`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkOfferActive(tenantId: number, couponMasterId: number) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}/mark_as_active`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  MarkOfferInActive(tenantId: number, couponMasterId: number) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponMasterId}/mark_as_inactive`,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleService(tenantId: number, couponId: number) {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_services_plans_products`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  addEligibleService(tenantId: number, couponId: number, payload:AddServiceCategoryRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_services_plans_products`, payload, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  removeEligibleService(tenantId: number, couponId: number, couponCodeServiceLinkId:number) {
    return this.http.delete(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_services_plans_products/${couponCodeServiceLinkId}`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleOrganization(tenantId: number, couponId: number) {
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_organisation`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  addEligibleOrganization(tenantId: number, couponId: number, payload:AddOrganisationRequest) {
    return this.http.post(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_organisation`, payload, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  removeEligibleOrganization(tenantId: number, couponId: number, couponmasterOrganizationId:number) {
    return this.http.delete(`${environment.BASE_URL}/tenants/${tenantId}/offer_master/${couponId}/eligible_organisation/${couponmasterOrganizationId}`, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getEligibleCoupons(tenantId:number, planId:number): Observable<EligibleCoupons>{
    return this.http.get(`${environment.BASE_URL}/tenants/${tenantId}/plans/${planId}/coupons`, this.httpOptions)
    .pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }



}
